import RunningTable from './RunningTable';

export default RunningTable;
